// extracted by mini-css-extract-plugin
export default {"root":"HomePageInformer__root--2u2IW","title":"HomePageInformer__title--9CeG_"};